module.exports = __webpack_public_path__ + "img/preview-1.e6b42c89.webp";